import { useAuth } from "@/context/AuthContext";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export default function Settings() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <div className="max-w-3xl space-y-6" data-testid="settings-page">
      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground">Account</p>
        <h1 className="mt-2 font-display text-3xl font-extrabold tracking-tighter">Settings</h1>
      </div>

      <div className="rounded-lg border border-border bg-white p-6">
        <h2 className="font-display text-lg font-semibold">Profile</h2>
        <dl className="mt-4 grid gap-4 sm:grid-cols-2 text-sm">
          <div><dt className="text-muted-foreground">Name</dt><dd className="font-medium" data-testid="settings-name">{user?.name}</dd></div>
          <div><dt className="text-muted-foreground">Email</dt><dd className="font-medium" data-testid="settings-email">{user?.email}</dd></div>
          <div><dt className="text-muted-foreground">Plan</dt><dd className="font-medium">{user?.plan}</dd></div>
          <div><dt className="text-muted-foreground">Credits remaining</dt><dd className="num font-medium">{user?.credits}</dd></div>
          <div><dt className="text-muted-foreground">Sign-in method</dt><dd className="font-medium capitalize">{user?.auth_provider}</dd></div>
          <div><dt className="text-muted-foreground">Email verified</dt>
            <dd><Badge variant="outline" className={user?.email_verified ? "bg-ok text-ok-foreground" : "bg-warn text-warn-foreground"}>
              {user?.email_verified ? "Verified" : "Not verified"}</Badge></dd></div>
        </dl>
      </div>

      <div className="rounded-lg border border-border bg-white p-6">
        <h2 className="font-display text-lg font-semibold">Privacy &amp; data</h2>
        <ul className="mt-3 space-y-2 text-sm text-muted-foreground">
          <li>• Uploaded files are processed for extraction and deleted from temporary storage immediately after.</li>
          <li>• Only document metadata, extracted transactions and analysis results are stored against your account.</li>
          <li>• Account numbers are masked (XXXXXX1234) everywhere in the app and in exports.</li>
          <li>• Documents are accessible only to your account; delete any document at any time.</li>
        </ul>
        <div className="mt-5 flex gap-3">
          <Button variant="outline" className="rounded-full bg-white" onClick={() => nav("/documents")}
                  data-testid="settings-manage-documents-btn">Manage documents</Button>
          <Button variant="outline" className="rounded-full bg-white"
                  onClick={async () => { await logout(); nav("/login"); }} data-testid="settings-logout-btn">
            Log out
          </Button>
        </div>
      </div>
    </div>
  );
}
